import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { CommonUtil } from '../../../../core/Utils/common-util';

@Component({
  selector: 'app-add-rfid-confirmation-modal',
  templateUrl: './add-rfid-confirmation-modal.component.html',
  styleUrls: ['./add-rfid-confirmation-modal.component.scss'],
})
export class AddRfidConfirmationModalComponent implements OnInit {
  @Input() successfulUsersCount: Number;
  @Input() failedUsersCount: Number;
  @Output() callOnBtnClick: EventEmitter<string> = new EventEmitter();
  @Input() failedUserInfo: [];
  @Input() numberOfUsers: Number;
  @Input() delinkRemoveMemberInfo: any;

  rootScopeData: RootScopeDeclare;
  successmessage: string;
  enableFailedmessage: boolean = false;
  failedmessage: any;
  modalTitle: string = '';

  constructor(private rootScopeService: RootScopeService, private commonUtil: CommonUtil) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }
  ngOnInit() {
    if(this.delinkRemoveMemberInfo) {
      let isDelink = this.delinkRemoveMemberInfo.isDelink;
      this.modalTitle = this.commonUtil.replaceValueAsHTMLOnTranslatedText('RFID.MEMBERS.REPORT', [this.commonUtil.translateText(isDelink ? 'DELINK.USER' : 'REMOVE')]);
      if(this.delinkRemoveMemberInfo.failedUserInfo?.length > 0) {
        this.enableFailedmessage = true;
        this.failedmessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText(isDelink ? 'FAILED.DELINK.MESSAGE' : 'FAILED.REMOVE.MESSAGE', 
          [this.delinkRemoveMemberInfo.failedUserInfo.length]);
      } else {
        this.successmessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText(isDelink ? 'SUCCESS.DELINK.USER.ACCOUNTS' : 'SUCCESS.REMOVE.USER.ACCOUNTS', 
        [this.delinkRemoveMemberInfo.numberOfUsers]);
      }
    } else {
      if (this.numberOfUsers > 0) {
        this.modalTitle = 'UPLOADED.MEMBERS.REPORT';
      } else {
        this.modalTitle = 'UNABLE.TO.PROCEED';
      }
  
      this.successmessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText('YOU.HAVE.UPLOADED.USER.ACCOUNTS', [
        this.successfulUsersCount?.toString(),
      ]);
  
      if (this.failedUsersCount > 0) {
        this.enableFailedmessage = true;
        this.failedmessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText('FAILED.UPLOAD.MESSAGE', [
          this.failedUsersCount?.toString(),
        ]);
      }
    } 
  }

  onNegativeButtonClick(): void {
    this.callOnBtnClick.emit();
  }

  onPositiveButtonClick(): void {
    this.callOnBtnClick.emit();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }
}
